/** Languages supported by the interface. Arabic (RTL) is out of scope for now. */
export const LANGUAGES = ['en', 'fr'] as const;
export type Language = (typeof LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = 'en';

/** Native names, shown as-is whatever the current interface language is. */
export const LANGUAGE_NATIVE_NAMES: Record<Language, string> = {
  en: 'English',
  fr: 'Français',
};

export const isLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value);
